'use client';

import { c as _c } from "react/compiler-runtime";
import { ChevronRightIcon } from '@heroicons/react/24/outline';
import type { MouseEventHandler } from 'react';
import { useMemo, useState } from 'react';
import type { ArrowAlignment } from '@src/components/SliderV2/useArrowYOffset';
import { useArrowYOffset } from '@src/components/SliderV2/useArrowYOffset';
import { useBreakpoints } from '@src/utils/breakpoints.util';
import { cn } from '@src/utils/tailwind';
export interface ArrowProps {
  isVisible?: boolean;
  isLeft?: boolean;
  isDarkMode?: boolean;
  isSkeleton?: boolean;
  /** Defaults to 'image'. */
  alignTo?: ArrowAlignment;
  onClick?: MouseEventHandler<HTMLButtonElement>;
}
const ARROW_SIZE = 40;
export function Arrow(props) {
  const $ = _c(20);
  const [arrowElement, setArrowElement] = useState(null);
  let t0;
  if ($[0] !== arrowElement || $[1] !== props.alignTo) {
    t0 = {
      arrowSize: ARROW_SIZE,
      arrowElement,
      alignTo: props.alignTo
    };
    $[0] = arrowElement;
    $[1] = props.alignTo;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const arrowYOffset = useArrowYOffset(t0);
  const {
    isLargeDesktop
  } = useBreakpoints();
  const arrowOffsetX = isLargeDesktop ? ARROW_SIZE + 24 : ARROW_SIZE + 10;
  const t1 = `${arrowYOffset}px`;
  let t2;
  if ($[3] !== arrowOffsetX || $[4] !== props.isLeft) {
    t2 = props.isLeft ? {
      left: `-${arrowOffsetX}px`
    } : {
      right: `-${arrowOffsetX}px`
    };
    $[3] = arrowOffsetX;
    $[4] = props.isLeft;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== props.isLeft) {
    t3 = props.isLeft ? {
      transform: "rotate(180deg)"
    } : {
      transform: "rotate(0deg)"
    };
    $[6] = props.isLeft;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t1 || $[9] !== t2 || $[10] !== t3) {
    t4 = {
      top: t1,
      width: ARROW_SIZE,
      height: ARROW_SIZE,
      ...t2,
      ...t3,
      boxShadow: "0px 1px 3px 0px #16181940"
    };
    $[8] = t1;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  const style = t4;
  const t5 = props.onClick;
  const t6 = !props.isVisible;
  const t7 = arrowYOffset === 0;
  let t8;
  if ($[12] !== t6 || $[13] !== t7) {
    t8 = cn("absolute z-10 hidden cursor-pointer items-center justify-center rounded-full border border-bodi-gray-medium bg-transparent p-0 transition-opacity duration-300 ease-in-out hover:border-bodi-gray-disabled hover:bg-bodi-white/5 focus:outline-none lg:flex", {
      "opacity-0": t6,
      "lg:hidden": t7
    });
    $[12] = t6;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <ChevronRightIcon className="ml-[2px] size-5 text-white" />;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== props.onClick || $[17] !== style || $[18] !== t8) {
    t10 = <button ref={setArrowElement} onClick={t5} style={style} className={t8}>{t9}</button>;
    $[16] = props.onClick;
    $[17] = style;
    $[18] = t8;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  return t10;
}